import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class PhotoService {
  public async downloadQuestionPhoto(photoId: any) {
    try {
      let response = await fetch(`${BASE_URL}/photos/download/${photoId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
}
